/* eslint-disable */
// tslint:disable
/**
 * profile
 * Описание API сервиса profile
 *
 * OpenAPI spec version: 0.1.0-rc.5
 * Contact: team@uchi.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  FetchAPI,
  FetchArgs,
  BaseAPI,
  RequiredError,
  defaultFetch,
} from './runtime';
import { Api } from './models';

export type FactoryFunction<T> = (
  configuration?: Configuration,
  basePath?: string,
  fetch?: FetchAPI,
) => T;

/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <p>Получить информацию о пользователе</p>
     * @param {Api.GetUserProfileIncludeEnum} [include] <p>Включить связанные объекты в выдачу</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserProfile(
      include: Api.GetUserProfileIncludeEnum | undefined,
      options: RequestInit = {},
    ): FetchArgs {
      let localVarPath = `/api/v1/users/me`;
      const localVarPathQueryStart = localVarPath.indexOf('?');
      const localVarRequestOptions: RequestInit = Object.assign(
        { method: 'GET' },
        options,
      );
      const localVarHeaderParameter: Headers = options.headers
        ? new Headers(options.headers)
        : new Headers();
      const localVarQueryParameter = new URLSearchParams(
        localVarPathQueryStart !== -1
          ? localVarPath.substring(localVarPathQueryStart + 1)
          : '',
      );
      if (localVarPathQueryStart !== -1) {
        localVarPath = localVarPath.substring(0, localVarPathQueryStart);
      }

      // authentication bearerAuth required
      // http authorization required
      if (configuration && configuration.authorization) {
        const localVarAuthorizationValue =
          typeof configuration.authorization === 'function'
            ? configuration.authorization('bearerAuth')
            : configuration.authorization;
        if (localVarAuthorizationValue !== null) {
          localVarHeaderParameter.set(
            'Authorization',
            'Bearer ' + localVarAuthorizationValue,
          );
        }
      }
      if (include !== undefined) {
        localVarQueryParameter.append('include', String(include));
      }

      localVarRequestOptions.headers = localVarHeaderParameter;

      const localVarQueryParameterString = localVarQueryParameter.toString();
      if (localVarQueryParameterString) {
        localVarPath += '?' + localVarQueryParameterString;
      }
      return {
        url: localVarPath,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  return {
    /**
     * <p>Получить информацию о пользователе</p>
     * @param {Api.GetUserProfileIncludeEnum} [include] <p>Включить связанные объекты в выдачу</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserProfile(
      include: Api.GetUserProfileIncludeEnum | undefined,
      options?: RequestInit,
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetUserProfile200Response> {
      const localVarFetchArgs = UserApiFetchParamCreator(configuration).getUserProfile(
        include,
        options,
      );
      return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
        return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(
          (response) => {
            const contentType = response.headers.get('Content-Type');
            const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;

            if (response.status === 200) {
              if (mimeType === 'application/json') {
                return response.json() as any;
              }
              throw response;
            }
            if (response.status === 401) {
              if (mimeType === 'application/json') {
                throw response;
              }
              throw response;
            }
            throw response;
          },
        );
      };
    },
  };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory: FactoryFunction<UserApi> = function (
  configuration?: Configuration,
  basePath?: string,
  fetch?: FetchAPI,
) {
  return new UserApi(configuration, basePath, fetch);
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   * <p>Получить информацию о пользователе</p>
   * @param {Api.GetUserProfileIncludeEnum} [include] <p>Включить связанные объекты в выдачу</p>
   * @param {RequestInit} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getUserProfile(
    include: Api.GetUserProfileIncludeEnum | undefined,
    options?: RequestInit,
  ) {
    return UserApiFp(this.configuration).getUserProfile(include, options)(
      this.fetch,
      this.basePath,
    );
  }
}

/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value: Date | string | undefined): string | undefined {
  if (value instanceof Date) {
    return value.toISOString();
  } else if (typeof value === 'string') {
    return value;
  } else {
    return undefined;
  }
}
